import { useQuery } from 'react-query';
import { trackPromise } from 'react-promise-tracker';
import { setInstanceServiceModeByGuid } from '../index';
export const useSetInstanceServiceModeByGuid = (guid, enabled) => useQuery(['SetInstanceServiceModeByGuid', guid], () => trackPromise(setInstanceServiceModeByGuid(guid)), {
    cacheTime: 0,
    enabled,
});
